import { render, staticRenderFns } from "./DuplicateExpensesWarningModal.vue?vue&type=template&id=7c879cfe&"
import script from "./DuplicateExpensesWarningModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateExpensesWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c879cfe')) {
      api.createRecord('7c879cfe', component.options)
    } else {
      api.reload('7c879cfe', component.options)
    }
    module.hot.accept("./DuplicateExpensesWarningModal.vue?vue&type=template&id=7c879cfe&", function () {
      api.rerender('7c879cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/DuplicateExpensesWarningModal.vue"
export default component.exports